module.exports = __webpack_public_path__ + "prince.jpg?77620d776fd38583bd8d568d46d6302d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prince.jpg
// module id = 161
// module chunks = 0